import { useCallback as l, useState as v, useEffect as N } from "react";
import { IDX_NOT_FOUND as s } from "../types.js";
function U(O, g) {
  const { vListHandle: u, idsToIndexes: r, indexesToIds: p } = O, o = l(() => {
    const e = u.current, t = (e == null ? void 0 : e.findStartIndex()) ?? s, n = (e == null ? void 0 : e.findEndIndex()) ?? s, c = p.get(t), w = p.get(n);
    return {
      oldestIndexInViewport: t,
      newestIndexInViewport: n,
      oldestIdInViewport: c,
      newestIdInViewport: w
    };
  }, [u, p]), [d, V] = v(
    () => o().newestIdInViewport
  ), [i, a] = v(
    () => o().oldestIdInViewport
  ), x = l(() => {
    const { newestIdInViewport: e, newestIndexInViewport: t } = o(), n = r.get(d ?? -1) ?? s, c = e !== void 0 && t !== s, w = n === s, S = n !== s && t > n;
    c && (w || S) && V(e);
  }, [o, r, d]), f = l(() => {
    const { oldestIdInViewport: e, oldestIndexInViewport: t } = o(), n = r.get(i ?? -1) ?? s, c = e !== void 0 && t !== s, w = n === s, S = n !== s && t < n;
    c && (w || S) && a(e);
  }, [o, r, i]), I = l(() => {
    x(), f();
  }, [x, f]);
  return N(() => {
    const { newestIdInViewport: e, oldestIdInViewport: t } = o();
    d === void 0 && e !== void 0 && V(e), i === void 0 && t !== void 0 && a(t), I();
  }, [o, d, i, I]), N(() => I(), [g, I]), {
    newestSeenId: d,
    oldestSeenId: i,
    newestSeenIndex: d ? r.get(d) : void 0,
    oldestSeenIndex: i ? r.get(i) : void 0,
    trackSeen: I
  };
}
export {
  U as useSeenIdsTracking
};
